import { feedbackCatalogContract } from "#shared/feedbackCatalogContract.ts";
import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";

function createFeedbackCatalogClient(baseUrl: string) {
    const link = new OpenAPILink(feedbackCatalogContract, {
        url: `${baseUrl}/api/analytics/feedback`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof feedbackCatalogContract> = createORPCClient(link);

    return createTanstackQueryUtils(client, { path: queryPath("analytics", ["feedback"]) });
}

export function useFeedbackCatalogClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createFeedbackCatalogClient(apiBaseUrl), [apiBaseUrl]);
}
